export default {
  "b2b.doplnkova-sluzba-detail.title-placeholder": "Doplňková služba",
  "b2b.doplnkova-sluzba-detail.message-empty":
    "Doplňková služba nebyla nalezena"
};
